import {
    HttpResponse,
    AuditTimingModel,
    QueryModel,
    RequestParams,
    AuditTimingModelIEnumerableApiResultSuccess,
    AuditTimingModelApiResultSuccess,
    ApiResultFailed,
    Operation,
    AggregationModel,
    AggregationResponse,
    GrouppedQueryModel
} from "@/libs/Api";
import ApiService from "@/libs/core/api-service"
import {CrudDataQuery, CrudService} from '@/libs/core/+state/models/crud-service';
import {CrudEnumerableResponse, CrudResponse} from "../core/+state/models/crud-response";
import {CrudPartialUpdatePatch} from '@/libs/core/+state/models/crud-partial-update-patch';

export class AuditTimingsDataService implements CrudService<AuditTimingModel, AuditTimingModel> {
    getAll(query: CrudDataQuery<AuditTimingModel>): Promise<CrudEnumerableResponse<AuditTimingModel>> {
        return ApiService.api.getAuditTimingBatch(query.pageIndex, query.pageSize, <any>query.data, query.params);
    }

    getBasicAll(query: CrudDataQuery<AuditTimingModel>): Promise<CrudEnumerableResponse<AuditTimingModel>> {
        throw new Error('NotImplemented');
    }

    get(id: string, params?: RequestParams): Promise<CrudResponse<AuditTimingModel>> {
        return ApiService.api.getAuditTimingById(id, params);
    }

    create(item: AuditTimingModel, params?: RequestParams): Promise<CrudResponse<AuditTimingModel>> {
        return ApiService.api.insertAuditTiming(item, params);
    }

    update(item: AuditTimingModel, params?: RequestParams): Promise<AuditTimingModel> {
        return ApiService.api.updateAuditTiming(item.id as Required<string>, item, params).then((req: any) => req.data.returnValue);
    }

    partialUpdate(id: string, patches: Operation[], params?: RequestParams): Promise<AuditTimingModel> {
        return ApiService.api.patchAuditTiming(id, patches, params).then((req: any) => req.data.returnValue);
    }

    delete(query: CrudDataQuery<AuditTimingModel>): Promise<CrudEnumerableResponse<AuditTimingModel>> {
        return ApiService.api.deleteAuditTimings(<any>query.data, query.params).then((req: any) => req.data.returnValue);
    }

    getAggregation(query: AggregationModel, params?: RequestParams): Promise<AggregationResponse> {
        return ApiService.api.aggregationAuditTiming(query, params).then((req: any) => req.data.returnValue);
    }
    
    download(query: CrudDataQuery<AuditTimingModel>): Promise<HttpResponse<any, ApiResultFailed | void>> {
        throw new Error('NotImplemented');
    }

    clone(item: AuditTimingModel, params?: RequestParams): Promise<CrudResponse<AuditTimingModel>> {
        throw new Error('NotImplemented');
    }

    getGroupped(query: GrouppedQueryModel, params?: RequestParams): Promise<CrudResponse<any>> {
        return ApiService.api.getAuditTimingGroupped(query, params);
    }

}
